import * as React from 'react';
import './popup.css';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { withLocalize, Translate } from "react-localize-redux";
import Select from 'react-select';
import {themeStyles, customSelectStyles} from '../themeStyles.js'
import { toast } from 'react-toastify';
const Loader = require('react-loader-spinner').default;

class CampaignUser extends React.Component<any, any> {
  closePopup: any;
  file: any

  constructor(props: any) {
    super(props);
    this.state = {
      updating: false,
      mediaToUpload: {
        name: "",
        type: null,
        text: "",
        mediatype: null,
        comments: ""
      },
      media: [],
      campaignId: 0,
      userId: 0
    }
    this.closePopup = this.props.closePopup
    this.loadCampaignUser = this.loadCampaignUser.bind(this)
    this.renderCellTextArea = this.renderCellTextArea.bind(this)

  }


  componentDidMount() {
    this.setState({
      campaignId: this.props.campaignId,
      userId: this.props.userId
    }, () => {
      this.loadCampaignUser()
    })
  }

  loadCampaignUser() {
    fetch('campaigns/getCampaignUser', {
      method: 'POST',
      body: JSON.stringify({userId: this.state.userId, campaignId: this.state.campaignId})
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaignUser = data.campaignUser
        let media = campaignUser.media
        this.setState({media})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      campaignId: nextProps.campaignId,
      userId: nextProps.userId
    }, () => {
      this.loadCampaignUser()
    })
  }


  addMedia(event: any) {
    event.preventDefault()
    let fileName = this.file.files[0].name
    let mediaToUpload = this.state.mediaToUpload
    mediaToUpload.name = fileName
    this.setState({mediaToUpload})
  }

  editMedia(event:any) {
    let name = event.target.name
    let value = event.target.value
    let mediaToUpload = this.state.mediaToUpload
    mediaToUpload[name] = value
    this.setState({mediaToUpload})
  }

  chooseType(selectedOption:any) {
    let mediaToUpload = this.state.mediaToUpload
    mediaToUpload.type = selectedOption.value
    this.setState({mediaToUpload})
  }

  chooseMediaType(selectedOption:any) {
    let mediaToUpload = this.state.mediaToUpload
    mediaToUpload.mediatype = selectedOption.value
    this.setState({mediaToUpload})
  }

  submitMedia(event:any) {
    event.preventDefault()

    this.setState({updating: true})

    let formData = new FormData();
    for (let key in this.state.mediaToUpload) {
      if (this.state.mediaToUpload[key] !== null) {
        let value = this.state.mediaToUpload[key]
        if(typeof(value) == 'object' && value.length > 0) {
          value = JSON.stringify(value)
        }
        formData.append(key, value);
      }
    }
    if (this.file.files.length > 0) {
      formData.set("file", this.file.files[0]);
    }
    formData.append("accountType", window.account.type || "")
    formData.append("accountId", window.account.id || "")
    formData.append("campaignId", this.state.campaignId)
    formData.append("userId", this.state.userId)


    fetch('campaigns/editMedia', {
      method: 'POST',
      body: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      },
    }).then(results => {
      return results.json();
    }).then(data => {
        let newMedia = data.newMedia
        let media = this.state.media
        media.push(newMedia)
        this.file = null
        this.setState({media,
          mediaToUpload: {
            name: "",
            type: null,
            text: "",
            mediatype: null,
            comments: ""
          }, updating: false
        })
    }).catch(err => {
      this.setState({updating: false})
      toast.error(err.message);
    })

  }

  changeMediaStatus(id:number, index: number, status:string) {
    if((status == "predeclined" || status == "declined") && this.state.media[index].comments.length == 0) {
      alert("עלייך לרשום הערה לפני דחיית התמונה")
      return
    }
    fetch('campaigns/editMedia', {
      method: 'POST',
      body: JSON.stringify({
        status,
        id,
        comments: this.state.media[index].comments,
        userId: this.state.userId,
        campaignId: this.state.campaignId,
      })
    }).then(results => {
      return results.json();
    }).then(data => {
      let media = this.state.media
      media[index].status = status
      this.setState({media})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  changeComments(index: number, event: any) {
    let media = this.state.media
    media[index].comments = event.target.value
    this.setState({media})
  }


  renderCellTextArea(celldata: any) {
    return <textarea onChange={this.changeComments.bind(this, celldata.index)} defaultValue={celldata.value.comments}></textarea>
  }

  public render() {
    let imageUrl = process.env.REACT_APP_AWS+"/campaigns/"+this.state.campaignId+"/"+this.state.userId
    const columns = [{
      id: "name",
      Header: this.props.translate("campaign.content"),
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div className="mediaApproval" style={{
        backgroundImage: row.value.mediatype == "image"? "url("+imageUrl+"/"+row.value.name+")" : ""
      }}>
        <span>{row.value.type}</span>
        {row.value.mediatype == "video" && <video controls autoPlay={false} width="100%" height="auto">
          <source src={imageUrl+"/"+row.value.name} type="video/mp4" />
        </video>}
        <a href={imageUrl+"/"+row.value.name} target="_blank"><i className="fas fa-external-link-alt"></i></a>
        <div className="icons">
          <i onClick={this.changeMediaStatus.bind(this, row.value.id, row.index, "acceepted")} className={row.value.status == "acceepted"? "active fas fa-thumbs-up" : "fas fa-thumbs-up"}></i>
          <i onClick={this.changeMediaStatus.bind(this, row.value.id, row.index, window.account.type == "admin"? "declined" : "predeclined")} className={row.value.status == "predeclined"? "preactive fas fa-thumbs-down" : row.value.status == "declined"? "active fas fa-thumbs-down" : "fas fa-thumbs-down"}></i>
        </div>
      </div>
    }, {
      id: 'text',
      Header: this.props.translate("campaign.postText"),
      resizable: false,
      maxWidth: 250,
      accessor: (d:any) => d,
      Cell: (row:any) => <p>{row.value.text}</p>
    }, {
      id: 'comments',
      Header: this.props.translate("campaign.postComments"),
      resizable: false,
      maxWidth: 200,
      accessor: (d:any) => d,
      Cell: this.renderCellTextArea
    }]

    return (
      <div id="popup-root" className="campaignUser">

      {this.state.updating && <div className="loadingDiv">
        <Loader
           type="Oval"
           color="#2d3444"
           height="100"
           width="100"
        />
      </div>}


          <i onClick={this.closePopup} className="fas fa-times"></i>

          <div className="container">
            <h2><Translate id="campaign.mediaApproval" /></h2>
            {window.account.type == "admin" && <div className="addMedia">
              <button className="primary-btn" onClick={(event:any) => {event.preventDefault(); this.file.click()}}>
                {this.state.mediaToUpload.name.length>0? this.state.mediaToUpload.name : this.props.translate("campaign.uploadMedia").toString()}
              </button>
              <input ref={el => this.file = el} onChange={this.addMedia.bind(this)} style={{display: "none"}} name="file" type="file" />
              <textarea name="text" value={this.state.mediaToUpload.text} onChange={this.editMedia.bind(this)} placeholder={this.props.translate("campaign.postComments")}></textarea>
              <div className="input third">
                <Select
                  onChange={this.chooseType.bind(this)}
                  value={this.state.mediaToUpload.type? {value: this.state.mediaToUpload.type, label: this.state.mediaToUpload.type} : null}
                  options={[{value: "feed", label: "Feed"}, {value: "story", label: "Story"}]}
                  menuPlacement={"bottom"}
                  placeholder={this.props.translate("campaign.chooseType").toString()}
                  theme={themeStyles}
                  styles={customSelectStyles}
                  className="multiSelect"
                  classNamePrefix="react-select"
                  isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
                />
              </div>
              <div className="input third">
                <Select
                  onChange={this.chooseMediaType.bind(this)}
                  value={this.state.mediaToUpload.mediatype? {value: this.state.mediaToUpload.mediatype, label: this.state.mediaToUpload.mediatype} : null}
                  options={[{value: "image", label: "Image"}, {value: "video", label: "Video"}]}
                  menuPlacement={"bottom"}
                  placeholder={this.props.translate("campaign.chooseMediaType").toString()}
                  theme={themeStyles}
                  styles={customSelectStyles}
                  className="multiSelect"
                  classNamePrefix="react-select"
                  isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
                />
              </div>
              <button className="primary-btn round" onClick={this.submitMedia.bind(this)}><i className="fas fa-upload"></i></button>
            </div>}



            <ReactTable
              data={this.state.media}
              columns={columns}
              defaultPageSize={5}
              noDataText={this.props.translate("noResults").toString()}
              nextText={this.props.translate("next").toString()}
              previousText={this.props.translate("previous").toString()}
              rowsText={this.props.translate("rows").toString()}
              pageText={this.props.translate("page").toString()}
              ofText={this.props.translate("of").toString()}
              style={{
                height: "600px",
                textAlign: "center",
                fontSize: "1em",
                position: "centner",
                right: "0",
                left: "0",
                margin: "0 auto",
                color: "#242424",
                overflow: "visible"
              }}
              className="-striped -highlight reactTable"
            />
          </div>

      </div>
    )
  }

}

export default withLocalize(CampaignUser)



// WEBPACK FOOTER //
// ./src/pages/campaign/popups/CampaignUser.tsx